export default {"src":"/_next/static/media/spinner.4c3ffb18.webp","height":289,"width":320,"blurWidth":0,"blurHeight":0};